(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('ExecutiveSummary', ExecutiveSummary)
      .factory('ExecutiveSummaryCard', ExecSummaryCard)
      .factory('ExecSummaryMetric', ExecSummaryMetricClass);

  function ExecutiveSummary(ExecutiveSummaryCard, ConsumerChartDisplay, HighChartsService, CalloutLabelService,
                            StandardReports, standardReportNumberFilter, SectionConfig){

    var verticalBarChartOptions = {
      plotOptions: {
        series: {
          clip: false,
          stacking: 'normal'
        }
      },
      chart: {
        type: 'column',
        height: 170,
        spacing: [10, 5, 10, 5]
      },
      xAxis: {
        labels: {
          enabled: false
        }
      }
    };

    var execSummaryCards = [
      ExecutiveSummaryCard('spu', 'lift', options(noFormat),
          [
            CalloutLabelService.tf()(SectionConfig.execSPU),
            CalloutLabelService.nonTF()(SectionConfig.execSPU),
            CalloutLabelService.sitewide()(SectionConfig.execSPU)
          ]
      ),
      ExecutiveSummaryCard('conversion', 'lift', options(percentFormat),
          [
            CalloutLabelService.tf()(SectionConfig.execConversion),
            CalloutLabelService.nonTF()(SectionConfig.execConversion),
            CalloutLabelService.sitewide()(SectionConfig.execConversion)
          ]),
      ExecutiveSummaryCard('aov', 'change', options(revenueFormat),
          [
            CalloutLabelService.tf()(SectionConfig.execAOV),
            CalloutLabelService.nonTF()(SectionConfig.execAOV),
            CalloutLabelService.sitewide()(SectionConfig.execAOV)
          ]),
      ExecutiveSummaryCard('upt', 'change', options(noFormat),
          [
            CalloutLabelService.tf()(SectionConfig.execUPT),
            CalloutLabelService.nonTF()(SectionConfig.execUPT),
            CalloutLabelService.sitewide()(SectionConfig.execUPT)
          ]),
      ExecutiveSummaryCard('arpu', 'change', options(revenueFormat),
          [
            CalloutLabelService.tf()(SectionConfig.execARPU),
            CalloutLabelService.nonTF()(SectionConfig.execARPU),
            CalloutLabelService.sitewide()(SectionConfig.execARPU)
          ])
    ];

    function colorSwatches() {
      var siteWideSwatch = {keys: [ConsumerChartDisplay.Colors.totalLine.stroke], value: 'Sitewide'};
      return StandardReports.getColorSwatches().concat(siteWideSwatch);
    }

    function percentFormat(value) {
      return standardReportNumberFilter(value) + "%";
    }

    function revenueFormat(value) {
      return "$" + standardReportNumberFilter(value);
    }

    function noFormat(value) {
      return standardReportNumberFilter(value);
    }

    function options(metricValuesFormat) {
      return {
        metricValuesFormat: metricValuesFormat
      }
    }

    function chartOptions() {
      var baseOptions = HighChartsService.getBaseOptions();
      return _.merge({}, baseOptions, verticalBarChartOptions);
    }

    function chartDataOptions(card) {
      return {
        yAxis: {
          title: false,
          min: 0,
          labels: {
            formatter: function () {
              return card.options.metricValuesFormat(this.value);
            }
          }
        },
        series: [
          {
            data: _.map(card.metricValues, function (summaryMetric) {
              return {
                y: summaryMetric.value || null,
                className: summaryMetric.colorClass
              }
            }),
            pointPadding: 0.25
          }
        ]
      };
    }

    return {
      cards: execSummaryCards,
      colorSwatches: colorSwatches,
      chartOptions: chartOptions,
      chartDataOptions: chartDataOptions
    };

  }

  function ExecSummaryCard(SectionConfig, CalloutLabelService) {

    function ExecutiveSummaryCard(key, changeAttribute, options, userCohortValues) {
      if (!(this instanceof ExecutiveSummaryCard)) return new ExecutiveSummaryCard(key, changeAttribute, options, userCohortValues);

      this.key = key;
      this.title = CalloutLabelService[changeAttribute]()(SectionConfig[key]).label;
      this.titleTooltip = CalloutLabelService[changeAttribute]()(SectionConfig[key]).tooltip;
      this.metricLabel = SectionConfig[key].key;
      this.metricTooltip = SectionConfig[key].chart.tooltip;
      this.options = options;
      this.userCohortValues = userCohortValues;
      this.change = null;
    }

    return ExecutiveSummaryCard;
  }

  function ExecSummaryMetricClass() {

    function ExecSummaryMetric(label, colorClass, userCohort, value) {
      if (!(this instanceof ExecSummaryMetric)) return new ExecSummaryMetric(label, colorClass, userCohort, value);

      this.label = label;
      this.colorClass = colorClass;
      this.userCohort = userCohort;
      this.value = value;
    }

    return ExecSummaryMetric;
  }
})();